<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Purchase Order Upload" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'financePurchaseOrderUpload',
          label: 'Purchase Order Upload',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" :filterBySaleType="false" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">id_no</th>
                <th align="left">item_id_no</th>
                <th align="left">vend_id_no</th>
                <th align="left">company</th>
                <th align="left">post_date</th>
                <th align="left">invoice_no</th>
                <th align="left">product_id_no</th>
                <th align="left">product_desc</th>
                <th align="left">batch_id</th>
                <th align="left">quantity</th>
                <th align="left">unit_cost</th>
                <th align="left">disc_amt</th>
                <th align="left">tax_amt</th>
                <th align="left">ship_amt</th>
                <th align="left">pord_tot</th>
                <th align="left">accn</th>
                <th align="left">cannabis</th>
                <th align="left">store_credit</th>
                <th align="left">noncannabis</th>
                <th align="left">store_id</th>
              </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(record, index) in reportData.records" :key="index">
                <td align="left">{{ record.id_no }}</td>
                <td align="left">{{ record.item_id_no }}</td>
                <td align="left">{{ record.vend_id_no }}</td>
                <td align="left">{{ record.company }}</td>
                <td align="left">{{ record.post_date }}</td>
                <td align="left">{{ record.invoice_no }}</td>
                <td align="left">{{ record.product_id_no }}</td>
                <td align="left">{{ record.product_desc }}</td>
                <td align="left">{{ record.batch_id }}</td>
                <td align="left">{{ record.quantity }}</td>
                <td align="left">{{ record.unit_cost }}</td>
                <td align="left">{{ record.disc_amt }}</td>
                <td align="left">{{ record.tax_amt }}</td>
                <td align="left">{{ record.ship_amt }}</td>
                <td align="left">{{ record.pord_tot }}</td>
                <td align="left">{{ record.accn }}</td>
                <td align="left">{{ record.cannabis }}</td>
                <td align="left">{{ record.store_credit }}</td>
                <td align="left">{{ record.noncannabis }}</td>
                <td align="left">{{ record.store_id }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Purchase Order Upload");
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    performGetReport(filter) {
      let reportType = "financePurchaseOrderUpload";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "BC_DF-import-PO");
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_financePurchaseOrderUpload.scss";
</style>